import axios from 'axios'
import usePim from '~/composables/pim_json_loader'
import {REGION_KEYS} from '~/assets/js/constants'

export const getCategoryFileName = (region) => {
  const normalizedRegion = (region || REGION_KEYS.GLOBAL).trim().toLowerCase()
  return `v1/${normalizedRegion}/search_startpage_categories.json`
}

export const useCategoryContentsService = () => {
  const baseurl = useRuntimeConfig().public.CMS_URL || 'https://cms-dev.dev.fst.com'

  const strapi_axios = axios.create({
    baseURL: baseurl
  })

  async function postCategoryContent(requestBody) {
    if (typeof requestBody === 'object') {
      return strapi_axios.post('/category-contents', requestBody)
    }
    return null
  }

  async function loadStartpageCategories(region) {
    const fileName = getCategoryFileName(region)
    const data = await usePim(fileName)
    const parsedData = typeof data === 'string' ? JSON.parse(data) : data
    return Array.isArray(parsedData) ? parsedData : []
  }

  return {
    postCategoryContent,
    loadStartpageCategories,
    getCategoryFileName
  }
}
